const dataRoutesQ1 = {
  isolation: 'isolation',
  chauffage: 'chauffage',
  'renovation-globale': 'renovationGlobale',
  'panneaux-solaires': 'photovoltaïque',
  thermostat: 'thermostat',
  'audit-energetique': 'auditEnergetique',
  'accompagnateur-renov': 'accompagnateurRenov',
  conseil: 'nonRenseigne',
};

export default dataRoutesQ1;
